"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _constants = require("./constants");

var API_BASE = 'cospages/v1/pages';
var DEFAULT_OPTIONS = {
  archived: false,
  campaign: null,
  folderId: null,
  isDraft: null,
  limit: _constants.ITEMS_PER_PAGE,
  name__icontains: null,
  offset: 0,
  order: _constants.PageProperties.NAME,
  translated_from_id__is_null: ' ',
  publish_date__lte: null,
  publish_date__gt: null,
  subcategory__in: ['site_page', 'landing_page'],
  state__in: _constants.PUBLISHED_STATES.toArray(),
  domain__nlike: ['%sandbox%hs-sites.com', '%sandbox%hs-sitesqa.com', 'classic-migration-sandbox%'],
  property: [_constants.PageProperties.ID, _constants.PageProperties.NAME, _constants.PageProperties.URL, _constants.PageProperties.PUBLIC_ACCESS_RULES_ENABLED]
};

var sanitizeQuery = function sanitizeQuery(query) {
  var sanitizedQuery = {};
  var search = query[_constants.PagesQueryParamNames.SEARCH];

  if (search) {
    sanitizedQuery['name__icontains'] = search;
  }

  var page = query[_constants.PagesQueryParamNames.PAGE];

  if (page) {
    sanitizedQuery.offset = _constants.ITEMS_PER_PAGE * (page - 1);
  }

  var ids = query[_constants.PagesQueryParamNames.IDS];

  if (ids) {
    sanitizedQuery['id__in'] = ids;
  }

  return sanitizedQuery;
};

var SitePagesAPI =
/*#__PURE__*/
function () {
  function SitePagesAPI() {
    (0, _classCallCheck2.default)(this, SitePagesAPI);
  }

  (0, _createClass2.default)(SitePagesAPI, null, [{
    key: "getPublishedPages",
    value: function getPublishedPages(_ref) {
      var params = _ref.params;
      return _apiClient.default.get(API_BASE, {
        query: (0, _extends2.default)({}, DEFAULT_OPTIONS, sanitizeQuery(params))
      });
    }
  }]);
  return SitePagesAPI;
}();

exports.default = SitePagesAPI;
module.exports = exports.default;